    const callNodeMailer = (name, email, phone_number, details, SignageTypes, data) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            name,
            email,
            details,
            "phone": phone_number,
            SignageTypes
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://signmakers-nodemailer.vercel.app/send", requestOptions)
            .then((response) => response.text())
            .then((result) => {
                // // console.log('');
                const resultObject = JSON.parse(result);
                if (resultObject.type == 'success') {
                    updateAirTableRow(data);
                } else {
                    // console.log('Error');
                }

            })
            .catch((error) => console.error(error));
    }

    const updateAirTableRow = (data) => {
        // Add the "Sent" field to the data object
        const apiKeySec = 'patJFpYWKie0BqndF.5eb591522e03a3e42f006c011f484b9e78f2493e05484b77aa313d5a4b15ac20';
        const dataToUpdate = {
                id:data.id,
                fields:{
                  SentStatus: "Email Sent",
                }
          }

        // Fetch request to update the Airtable row
        fetch(`https://api.airtable.com/v0/apphaeSdThQQ8dbA8/Projects`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${apiKeySec}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                records: [dataToUpdate] // Wrap the data in an array under "records"
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(updatedRecords => {
                console.log('');
            })
            .catch(error => {
                console.error('Error updating records:', error);
            });
    };